import { z } from "zod";

import { castToNumber } from "../utils";
// import { OfferProductInclusionTypeList } from "./product-variants";

export const OfferProductInclusionTypeList = ["include", "exclude"] as const;
export type OfferProductInclusionType =
  (typeof OfferProductInclusionTypeList)[number];

const OfferProductVariantDtoSchema = z.object({
  id: z.string(),
  title: z.string(),
  price: castToNumber,
  compareAtPrice: castToNumber.nullish(),
});

export type OfferProductVariantDto = z.infer<
  typeof OfferProductVariantDtoSchema
>;

export const OfferProductDtoSchema = z.object({
  id: z.string(),
  title: z.string(),
  image: z.string().nullish(),
  variants: OfferProductVariantDtoSchema.array(),
  variationId: z.string().uuid(),
  offerId: z.string().uuid().nullable(),
  inclusionType: z
    .enum(OfferProductInclusionTypeList)
    .optional()
    .default("include"),
});

export type OfferProductDto = z.infer<typeof OfferProductDtoSchema>;
